<script setup>
import { useAuthedImage } from "@/shared/lib/composables/useAuthedImage";

const props = defineProps({
  photo: {
    type: String,
    default: "",
  },
  alt: {
    type: String,
    default: "",
  },
});

const { src: photoSrc, error: photoError } = useAuthedImage(() => props.photo);
</script>

<template>
  <img
    v-if="photoSrc && !photoError"
    :src="photoSrc"
    :alt="alt"
    class="w-10 h-12 object-cover rounded-md border border-border shrink-0"
    @error="photoError = true"
  />
</template>
